// production сборка для версии nuxt.js
import Vue from 'vue'
import Validate2 from './utils/validate2'
import '@/assets/global.scss'
import ToastPlugin from '@/components/core/toast.plugin'
import TranslatePlugin from '@/components/core/translate.plugin'
import UserContext from '@/components/core/user.context'

Vue.use(Validate2)
Vue.use(ToastPlugin)
Vue.use(TranslatePlugin)
Vue.use(UserContext)

export default {
  install (Vue, options) {
  }
}
